export default __webpack_public_path__ + "d49618124b4470e6d3c964d66daf4737.png";